var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('div',{staticClass:"embed-responsive",class:[_vm.css]},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"sandbox":"allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation","title":"Instructional Video","allowfullscreen":"","src":(_vm.url) + '&texttrack=en'}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }